export default {
  shipTo: {
    id: 'funnel_summary_addresses_card_ship_to',
    defaultMessage: 'Ship to {fullName}',
  },
  billTo: {
    id: 'funnel_summary_addresses_card_bill_to',
    defaultMessage: 'Bill to {fullName}',
  },
  modify: {
    id: 'funnel_summary_addresses_card_modify',
    defaultMessage: 'Modify',
  },
  modifyShippingAddress: {
    id: 'funnel_summary_addresses_card_modify_shipping_address',
    defaultMessage: 'Modify the shipping address',
  },
  modifyBillingAddress: {
    id: 'funnel_summary_addresses_card_modify_billing_address',
    defaultMessage: 'Modify the billing address',
  },
}
